export default "__VITE_PUBLIC_ASSET__cbf758f4__"